import { parseRequiredDate, parseOptionalDate } from '../../utils/parsing';
import { ApiKey, ListResponse } from './types';

// TODO: [axios] use zog?

type StringyItem<T extends ApiKey> = Omit<T, 'created_at' | 'expires_at'> & {
  created_at: string;
  expires_at?: string;
};

type StringyListResponse = Omit<ListResponse, 'keys'> & {
  keys: StringyItem<ApiKey>[];
};

export function parseList(value: string | StringyListResponse): ListResponse {
  if (typeof value === 'string') {
    value = JSON.parse(value) as StringyListResponse;
  }
  return {
    ...value,
    keys: value.keys.map(parseItem),
  };
}

export function parseItem<T extends ApiKey>(value: string | StringyItem<T>): T {
  if (typeof value === 'string') {
    value = JSON.parse(value) as StringyItem<T>;
  }
  return {
    ...value,
    created_at: parseRequiredDate(value.created_at),
    expires_at: parseOptionalDate(value.expires_at),
  } as T;
}
